import EmptyState from "../components/shared/EmptyState";
import ErrorState from "../components/shared/ErrorState";
import LoadingState from "../components/shared/LoadingState";
import RoundsTable from "../components/rounds/RoundsTable";
import { Container } from "@mui/material";
import { hasVisibleRoundResults, isCompetitionVisibleInResults } from "../utils/resultPublicationUtils";
import { RoundResult } from "../interfaces/ICompetitions";
import { useCategoryContext } from "../contexts/CategoryContext";
import { useNavigationHelper } from "../hooks/useNavigationHelper";

export default function RoundsList() {
  const { category, competition, loading, error } = useCategoryContext();
  const { goToResults, goToCategories } = useNavigationHelper();

  if (loading) {
    return (
      <Container maxWidth="lg" sx={{ py: 4 }}>
        <LoadingState message="Ładowanie rund..." />
      </Container>
    );
  }

  if (error) {
    return (
      <Container maxWidth="lg" sx={{ py: 4 }}>
        <ErrorState message={error} />
      </Container>
    );
  }

  if (!competition || !category) {
    return (
      <Container maxWidth="lg" sx={{ py: 4 }}>
        <EmptyState message="Nie znaleziono kategorii" />
      </Container>
    );
  }

  if (!isCompetitionVisibleInResults(competition) || !hasVisibleRoundResults(competition, category)) {
    return (
      <Container maxWidth="lg" sx={{ py: 4 }}>
        <ErrorState message="Dla tej kategorii nie opublikowano wyników" />
      </Container>
    );
  }

  const handleBack = () => {
    goToCategories(competition.id);
  };

  const handleRowClick = (round: RoundResult) => {
    goToResults(competition.id, category.categoryId, round.roundId);
  };

  return (
    <Container maxWidth="lg" sx={{ py: 2 }}>
      <RoundsTable
        rounds={category.rounds}
        competitionId={competition.id}
        categoryId={category.categoryId}
        onRowClick={handleRowClick}
        onBack={handleBack}
      />
    </Container>
  );
}
